import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="w-full bg-navy py-8 px-6 text-center flex flex-col items-center space-y-2" data-id="element-70">
        <p className="font-sans text-xs text-[#C8D8E8]" data-id="element-71">
          © 2025 GoDeskCore &middot; PROSPERA &middot; Todos los derechos
          reservados. Roderic Guillen.
        </p>
        <div className="flex items-center justify-center gap-2 font-sans text-xs text-[#C8D8E8]" data-id="element-72">
          <button onClick={() => setActiveModal('privacy')} className="hover:text-gold transition-colors duration-200 bg-transparent border-none cursor-pointer text-[#C8D8E8] text-xs font-sans" data-id="element-73">
            Política de Privacidad
          </button>
          <span data-id="element-74">&middot;</span>
          <button onClick={() => setActiveModal('terms')} className="hover:text-gold transition-colors duration-200 bg-transparent border-none cursor-pointer text-[#C8D8E8] text-xs font-sans" data-id="element-75">
            Términos de Uso
          </button>
          <span data-id="element-76">&middot;</span>
          <a href="mailto:godeskcore@gmail.com" className="hover:text-gold transition-colors duration-200" data-id="element-77">
            Contacto
          </a>
        </div>
      </footer>

      <AnimatePresence data-id="element-78">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 px-4 py-8" onClick={() => setActiveModal(null)} data-id="element-79">
            <motion.div initial={{
          opacity: 0,
          y: 20,
          scale: 0.97
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 20,
          scale: 0.97
        }} transition={{
          duration: 0.3
        }} className="bg-white rounded-2xl w-full max-w-2xl max-h-[85vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-80">
              <div className="sticky top-0 bg-white border-b border-navy/10 px-8 py-5 flex items-center justify-between rounded-t-2xl z-10" data-id="element-81">
                <h2 className="text-xl font-serif font-bold text-navy" data-id="element-82">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos de Uso'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="text-[#888888] hover:text-navy transition-colors bg-transparent border-none cursor-pointer text-2xl leading-none" aria-label="Cerrar" data-id="element-83">
                  &times;
                </button>
              </div>

              <div className="px-8 py-6 text-[15px] font-sans text-[#4A4A4A] leading-[1.85] space-y-6" data-id="element-84">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-85" /> : <TermsContent data-id="element-86" />}
              </div>

              <div className="sticky bottom-0 bg-white border-t border-navy/10 px-8 py-4 rounded-b-2xl" data-id="element-87">
                <button onClick={() => setActiveModal(null)} className="w-full bg-navy text-white font-sans font-bold text-sm py-3 rounded-lg hover:brightness-90 transition-all duration-200" data-id="element-88">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-xs text-[#888888]" data-id="element-89">Última actualización: Julio 2025</p>

      <div data-id="element-90">
        <h3 className="text-lg font-serif font-bold text-navy mb-2" data-id="element-91">
          1. Responsable del Tratamiento
        </h3>
        <p data-id="element-92">
          GoDeskCore, operado por Roderic Guillen, es responsable del
          tratamiento de los datos personales recogidos a través de este sitio
          web y la venta del ebook "Marta, Don Raúl y la Inteligencia
          Artificial".
        </p>
      </div>

      <div data-id="element-93">
        <h3 className="text-lg font-serif font-bold text-navy mb-2" data-id="element-94">
          2. Datos que Recopilamos
        </h3>
        <p data-id="element-95">
          Recopilamos únicamente los datos necesarios para procesar tu compra:
        </p>
        <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-96">
          <li data-id="element-97">Nombre completo</li>
          <li data-id="element-98">Dirección de correo electrónico</li>
          <li data-id="element-99">
            Información de pago (procesada de forma segura por nuestro proveedor
            de pagos)
          </li>
        </ul>
      </div>

      <div data-id="element-100">
        <h3 className="text-lg font-serif font-bold text-navy mb-2" data-id="element-101">
          3. Finalidad del Tratamiento
        </h3>
        <p data-id="element-102">Tus datos se utilizan exclusivamente para:</p>
        <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-103">
          <li data-id="element-104">Procesar y entregar tu compra del ebook</li>
          <li data-id="element-105">Enviarte el enlace de descarga del producto</li>
          <li data-id="element-106">Atender solicitudes de soporte relacionadas con tu compra</li>
          <li data-id="element-107">
            Gestionar posibles devoluciones dentro del período de garantía
          </li>
        </ul>
      </div>

      <div data-id="element-108">
        <h3 className="text-lg font-serif font-bold text-navy mb-2" data-id="element-109">
          4. No Compartimos tus Datos
        </h3>
        <p data-id="element-110">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros con fines comerciales. Tus datos solo se comparten con los
          proveedores de servicios estrictamente necesarios para procesar tu
          compra (pasarela de pago y plataforma de entrega digital).
        </p>
      </div>

      <div data-id="element-111">
        <h3 className="text-lg font-serif font-bold text-navy mb-2" data-id="element-112">
          5. Seguridad
        </h3>
        <p data-id="element-113">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tus datos personales contra acceso no autorizado, pérdida o
          alteración. Todas las transacciones se procesan mediante conexiones
          cifradas (SSL/TLS).
        </p>
      </div>

      <div data-id="element-114">
        <h3 className="text-lg font-serif font-bold text-navy mb-2" data-id="element-115">
          6. Tus Derechos
        </h3>
        <p data-id="element-116">Tienes derecho a:</p>
        <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-117">
          <li data-id="element-118">Acceder a tus datos personales</li>
          <li data-id="element-119">Solicitar la rectificación de datos inexactos</li>
          <li data-id="element-120">Solicitar la eliminación de tus datos</li>
          <li data-id="element-121">Oponerte al tratamiento de tus datos</li>
        </ul>
        <p className="mt-2" data-id="element-122">
          Para ejercer cualquiera de estos derechos, escríbenos a{' '}
          <strong data-id="element-123">godeskcore@gmail.com</strong>.
        </p>
      </div>

      <div data-id="element-124">
        <h3 className="text-lg font-serif font-bold text-navy mb-2" data-id="element-125">
          7. Cookies
        </h3>
        <p data-id="element-126">
          Este sitio utiliza cookies técnicas esenciales para el funcionamiento
          del sitio web. No utilizamos cookies de seguimiento publicitario ni de
          terceros con fines de marketing.
        </p>
      </div>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-xs text-[#888888]" data-id="element-127">Última actualización: Julio 2025</p>

      <div data-id="element-128">
        <h3 className="text-lg font-serif font-bold text-navy mb-2" data-id="element-129">
          1. Identificación
        </h3>
        <p data-id="element-130">
          Este sitio web y el producto digital "Marta, Don Raúl y la
          Inteligencia Artificial" son propiedad de GoDeskCore, operado por
          Roderic Guillen bajo la marca PROSPERA.
        </p>
      </div>

      <div data-id="element-131">
        <h3 className="text-lg font-serif font-bold text-navy mb-2" data-id="element-132">
          2. Producto Digital
        </h3>
        <p data-id="element-133">
          El producto ofrecido es un ebook en formato PDF de descarga digital
          inmediata. Al completar la compra, recibirás acceso inmediato al
          archivo PDF, compatible con cualquier dispositivo.
        </p>
      </div>

      <div data-id="element-134">
        <h3 className="text-lg font-serif font-bold text-navy mb-2" data-id="element-135">
          3. Precio y Pago
        </h3>
        <p data-id="element-136">
          El precio del ebook es de $12.97 USD (pago único). No existen cargos
          recurrentes, suscripciones ni renovaciones automáticas. El pago se
          procesa de forma segura a través de nuestra plataforma de comercio
          electrónico.
        </p>
      </div>

      <div data-id="element-137">
        <h3 className="text-lg font-serif font-bold text-navy mb-2" data-id="element-138">
          4. Entrega
        </h3>
        <p data-id="element-139">
          Tras completar el pago, recibirás acceso inmediato al ebook en formato
          PDF a través de un enlace de descarga enviado a tu correo electrónico.
          Si no recibes el enlace en un plazo de 15 minutos, revisa tu carpeta
          de spam o contáctanos.
        </p>
      </div>

      <div data-id="element-140">
        <h3 className="text-lg font-serif font-bold text-navy mb-2" data-id="element-141">
          5. Garantía de Satisfacción
        </h3>
        <p data-id="element-142">
          Ofrecemos una garantía de satisfacción de 7 días desde la fecha de
          compra. Si el producto no cumple tus expectativas, puedes solicitar un
          reembolso completo escribiendo a <strong data-id="element-143">godeskcore@gmail.com</strong>
          . No se requiere justificación.
        </p>
      </div>

      <div data-id="element-144">
        <h3 className="text-lg font-serif font-bold text-navy mb-2" data-id="element-145">
          6. Propiedad Intelectual
        </h3>
        <p data-id="element-146">
          Todo el contenido del ebook, incluyendo textos, diseño, ilustraciones
          y estructura narrativa, está protegido por derechos de autor. La
          compra otorga una licencia personal e intransferible para uso
          individual. Queda prohibida la reproducción, distribución o reventa
          total o parcial del contenido sin autorización expresa del autor.
        </p>
      </div>

      <div data-id="element-147">
        <h3 className="text-lg font-serif font-bold text-navy mb-2" data-id="element-148">
          7. Uso Permitido
        </h3>
        <p data-id="element-149">Al adquirir el ebook, puedes:</p>
        <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-150">
          <li data-id="element-151">Leerlo en cualquier dispositivo personal</li>
          <li data-id="element-152">Imprimirlo para uso personal</li>
          <li data-id="element-153">Hacer anotaciones para tu uso privado</li>
        </ul>
        <p className="mt-2" data-id="element-154">No está permitido:</p>
        <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-155">
          <li data-id="element-156">Compartir el archivo con terceros</li>
          <li data-id="element-157">Publicar el contenido en internet</li>
          <li data-id="element-158">Utilizar el contenido con fines comerciales sin autorización</li>
        </ul>
      </div>

      <div data-id="element-159">
        <h3 className="text-lg font-serif font-bold text-navy mb-2" data-id="element-160">
          8. Limitación de Responsabilidad
        </h3>
        <p data-id="element-161">
          El contenido del ebook tiene fines educativos y narrativos. No
          constituye asesoramiento profesional, técnico, legal ni financiero.
          GoDeskCore no se hace responsable de las decisiones tomadas por el
          lector basándose en el contenido del libro.
        </p>
      </div>

      <div data-id="element-162">
        <h3 className="text-lg font-serif font-bold text-navy mb-2" data-id="element-163">
          9. Modificaciones
        </h3>
        <p data-id="element-164">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones serán efectivas desde su publicación en
          este sitio web.
        </p>
      </div>
    </>;
}